import axios from "axios";
import swal from "@sweetalert/with-react";
import moment from "moment";
import { baseurl } from "../../../baseurl";
let username = localStorage.getItem("username");
let companyId = localStorage.getItem("companyId");
let token = localStorage.getItem("token");

export async function CheckClosingYearD(
  date,
  tableName,
  invoiceType,
  invBookId,
  dateColumn,
  documentNo,
  byDefault,
  orderTypeId
) {
  date = moment(date).format("YYYY-MM-DD");
  let year = "";
  let data = "";
  var checkDate = "";

  let docNo;
  let inv;
  await axios
    .post(
      `${baseurl}/company/getClosingDate`,
      {
        username: username,
        companyId: companyId,
        date: date,
        invBookId: invBookId,
        tableName: tableName,
        invoiceType: invoiceType,
        dateColumn: dateColumn,
        documentNo: documentNo,
        orderTypeId: orderTypeId,
      },
      {
        headers: {
          authorization: token,
        },
      }
    )
    .then((res) => {
      data = res;
      docNo = res.data.data2[0]["max_num"];
      year = res.data.data[0]["closingDate"];
      const dateFormat = "YYYY-MM-DD";
      const toDateFormat = moment(new Date(year)).format(dateFormat);
      checkDate = moment(toDateFormat, dateFormat, true).isValid();
      console.log("docNodocNo", docNo);

      if (checkDate === true) {
        if (byDefault === "") {
          swal({
            title: "Financial Year is Closed",
            text: "Please Select Valid Date",
            icon: "error",
          });
        }
      }
    })
    .catch((err) => {
      if (byDefault === "") {
        swal({
          title: "Fiscal Year dosen't Exist",
          text: "Please Select Valid Date",
          icon: "error",
        });
      }
      console.log(err);
    });

  return [checkDate, docNo];
}

export async function getDocNumberDynamic(tableName, docNoCol) {
  // date = moment(date).format("YYYY-MM-DD");
  // let year = "";
  // let data = "";
  // var checkDate = "";
  let new_docNo = -1;
  await axios
    .post(
      `${baseurl}/lovs/getMaxDocNo`,
      {
        username: username,
        companyId: companyId,
        tableName,
        docNoCol,
      },
      {
        headers: {
          authorization: token,
        },
      }
    )
    .then((res) => {
      // data = res;
      new_docNo = res.data.data[0]["max_num"];
      // year = res.data.data[0]["closingDate"];
      // const dateFormat = "YYYY-MM-DD";
      // const toDateFormat = moment(new Date(year)).format(dateFormat);
      // checkDate = moment(toDateFormat, dateFormat, true).isValid();
      // console.log("docNodocNo", new_docNo);

      // if (checkDate === true) {
      //   // if (byDefault === "") {
      //   //   swal({
      //   //     title: "Financial Year is Closed",
      //   //     text: "Please Select Valid Date",
      //   //     icon: "error",
      //   //   });
      //   // }
      // }
    })
    .catch((err) => {
      // if (byDefault === "") {
      //   swal({
      //     title: "Fiscal Year dosen't Exist",
      //     text: "Please Select Valid Date",
      //     icon: "error",
      //   });
      // }
      console.log(err);
    });

  return [new_docNo];
}
